export default "__VITE_ASSET__BShwtmpF__"